// 🧿 طلسم محافظ فایل

import React from "react";
// Common Components
import { WrappedTimeSeriesChart } from "src/Components";
// Requests
import { getIVGraph } from "src/Requests/automaticMarketMaking";
// Types
import { IVChartData } from "src/Interfaces/automaticMarketMaking";

interface IProps {
  tableId: string;
}

const IVGraph: React.FC<IProps> = ({ tableId }) => {
  const [dataSet, setDataSet] = React.useState<IVChartData[]>([]);

  React.useEffect(() => {
    let isCurrent = true; // Tracks if the request is for the current tableId
    let intervalId: NodeJS.Timeout;

    // Function to fetch data
    const fetchData = async () => {
      try {
        const data = await getIVGraph(tableId);
        if (isCurrent) {
          // Only update state if the tableId hasn't changed
          setDataSet(data);
        }
      } catch (error) {
        if (isCurrent) {
          console.error("Error fetching IVGraph data:", error);
        }
      }
    };

    // Initial fetch
    fetchData();

    // Set up interval to fetch every 30 seconds
    intervalId = setInterval(fetchData, 30_000);

    // Cleanup: clear interval and mark requests as outdated when tableId changes or component unmounts
    return () => {
      isCurrent = false;
      clearInterval(intervalId);
    };
  }, [tableId]);

  return (
    <div className="w-1/2 h-1/2" onClick={(e) => e.stopPropagation()}>
      <div className="flex flex-row h-full w-full">
        <div className="h-full w-full">
          <WrappedTimeSeriesChart dataset={dataSet} />
        </div>
        <div className="flex-row justify-center content-center rotate-[-90deg]">
          IV
        </div>
      </div>
    </div>
  );
};

export default IVGraph;
